var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelsInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "models-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.93933578,12.7777778 C4.54765779,16.4037448 7.70117141,19.1666667 11.5,19.1666667 C15.2988286,19.1666667 18.4523422,16.4037448 19.0606642,12.7777778 L15.3333333,12.7777778 C15.3333333,14.8948693 13.6170915,16.6111111 11.5,16.6111111 C9.38290846,16.6111111 7.66666667,14.8948693 7.66666667,12.7777778 L3.93933578,12.7777778 Z M4.26958125,8.94444444 L18.7304187,8.94444444 C17.6779479,5.9667306 14.8381148,3.83333333 11.5,3.83333333 C8.16188522,3.83333333 5.32205207,5.9667306 4.26958125,8.94444444 Z M11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 C17.8512746,0 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "models-inactive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    d: "M3.19967289,12.9018697 L3.05302805,12.0277778 L3.93933578,12.0277778 L8.41666667,12.0277778 L8.41666667,12.7777778 C8.41666667,14.4806558 9.79712202,15.8611111 11.5,15.8611111 C13.202878,15.8611111 14.5833333,14.4806558 14.5833333,12.7777778 L14.5833333,12.0277778 L19.9469719,12.0277778 L19.8003271,12.9018697 C19.1248539,16.9280983 15.626087,19.9166667 11.5,19.9166667 C7.373913,19.9166667 3.87514607,16.9280983 3.19967289,12.9018697 Z M19.7909748,9.69444444 L3.20902519,9.69444444 L3.56245134,8.69450988 C4.74147753,5.35873796 7.90441096,3.08333333 11.5,3.08333333 C15.095589,3.08333333 18.2585225,5.35873796 19.4375487,8.69450988 L19.7909748,9.69444444 Z M11.5,22.25 C17.4370611,22.25 22.25,17.4370611 22.25,11.5 C22.25,5.56293894 17.4370611,0.75 11.5,0.75 C5.56293894,0.75 0.75,5.56293894 0.75,11.5 C0.75,17.4370611 5.56293894,22.25 11.5,22.25 Z",
    strokeLinejoin: "square",
    fillOpacity: 0.15,
    fill: "#2E2B2B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#2E2B2B",
    strokeWidth: 1,
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelsInactive);
export default __webpack_public_path__ + "static/media/models-inactive.6b42fc9ccb8cf54cb2715d591667e056.svg";
export { ForwardRef as ReactComponent };